var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFalsePositive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-False_Positive"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "False_Positive",
    "data-name": "False Positive",
    clipPath: "url(#clip-False_Positive)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-2.247 -2.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M71.267,33.227a34.605,34.605,0,1,0-38.04,38.04,34.605,34.605,0,1,0,38.04-38.04ZM50.145,31.74l-12.3,15.38a3.845,3.845,0,0,1-2.666,1.435h-.359a3.794,3.794,0,0,1-2.461-.872l-8.2-7.024a3.845,3.845,0,0,1-.513-5.383,3.9,3.9,0,0,1,5.434-.513L34.2,39.072,44.1,26.614a3.965,3.965,0,0,1,6.049,5.127ZM77.88,72.754a3.625,3.625,0,1,1-5.127,5.127l-5.127-5.127L62.5,77.88a3.625,3.625,0,1,1-5.127-5.127L62.5,67.627,57.374,62.5A3.845,3.845,0,0,1,62.5,57.374L67.627,62.5l5.127-5.127A3.845,3.845,0,0,1,77.88,62.5l-5.127,5.127Z",
    transform: "translate(0 0)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalsePositive);
export default __webpack_public_path__ + "static/media/false-positive.878617ac5710b761bbb7efbe8bf6822b.svg";
export { ForwardRef as ReactComponent };